// extracted by mini-css-extract-plugin
export default {"keyDetails":"styles_keyDetails__OQHW0","kdWrap":"styles_kdWrap__Q7Msi","icon":"styles_icon__q+yq-"};